'use client';

import { useEffect, useMemo, useRef } from 'react';
import { getTotalItemsOfCarts } from 'components/commercetools-ui/organisms/cart/helpers';
import { useAccount, useCart } from 'frontastic';
import { useMessagePort } from '.';

const CartStatusMessenger = () => {
  const { accountLoaded, loggedIn } = useAccount();
  const { miniCarts, miniCartsLoaded } = useCart();
  const { isReady, sendCartStatus } = useMessagePort();
  const lastSentItemCount = useRef<number | undefined>(undefined);
  const itemCount = useMemo(() => getTotalItemsOfCarts(loggedIn ? miniCarts : []), [loggedIn, miniCarts]);
  const cartStateLoaded = accountLoaded && (!loggedIn || miniCartsLoaded);

  useEffect(() => {
    if (!isReady || !cartStateLoaded || lastSentItemCount.current === itemCount) return;

    sendCartStatus(itemCount);
    lastSentItemCount.current = itemCount;
  }, [cartStateLoaded, isReady, itemCount, sendCartStatus]);

  return null;
};

export default CartStatusMessenger;
